import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/theme";  // Iter-191 · sets .dark class from localStorage on boot
import App from "@/App";

// Benign browser warning (dialogs/dropdowns resizing) — keep it from triggering the dev error overlay.
window.addEventListener("error", (e) => {
  if (String(e?.message || "").includes("ResizeObserver loop")) { e.stopImmediatePropagation(); e.preventDefault(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
